module.exports = __webpack_public_path__ + "static/media/profile.823418fe.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/profile.jpeg
// module id = 64
// module chunks = 0